import styled, { keyframes } from 'styled-components';
import { Title, Text, Section as BaseSection } from '../../utils/theme';

export const Section = styled(BaseSection)`
  min-height: 0vh;
  position: relative;
  box-shadow: 0 0 5vw 5vw #090C1B inset;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const RecapTitle = styled(Title)`
  text-align: center;
  margin: 0 auto 0vw auto;
  font-size: 4vw;

  @media (max-width: 600px) {
    font-size: 7.25vw;
  }
`;

export const RecapSubTitle = styled(Text)`
  text-align: center;
  margin: 0 auto 5vw auto;
  font-size: 3vw;

  @media (max-width: 600px) {
    font-size: 5.25vw;
  }
`;

export const Card = styled.div`
  display: flex;
  text-align: left;

  @media (max-width: 600px) {   /*breakpoint for tablets and smaller devices */
    font-size: 3.6vw;
    align-items: center;
    flex-direction: column-reverse;
    text-align: center;
  }
`; 

export const Headshot = styled.img`
  width: 60vw;
  margin: auto 0vw;
  border: solid 0.5vw;
  border-radius: 0.5vw;

  @media (max-width: 600px) {
    width: 88vw;
    margin: 5vw;
  }
`

export const CardColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: space-around;
`

export const CardText = styled(Text)`
  margin: 0 auto;
  font-size: 1.5vw;
  width: 100%;

  @media (max-width: 600px) {
    font-size: 3.25vw;
  }
`

export const Embla = styled.div`
  max-width: 120vw;
  left: 10vw;
  margin: auto;
  --slide-height: fit-content;
  --slide-spacing: 5vw;
  --slide-size: 62vw;

  @media (max-width: 600px) {
    --slide-size: 90vw;
  }
`

export const EmblaViewport = styled.div`
  overflow: visible;
`

export const EmblaContainer = styled.div`
  display: flex;
  touch-action: pan-y pinch-zoom;
  margin-left: calc(var(--slide-spacing) * -1);
  align-items: center;
`

export const EmblaSlide = styled.div`
  transform: translate3d(0, 0, 0);
  flex: 0 0 var(--slide-size);
  min-width: 0;
  padding-left: var(--slide-spacing);
`

export const EmblaSlideNumber = styled.div`
  box-shadow: inset 0 0 0 0.2rem var(--detail-medium-contrast);
  border-radius: 1.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  height: var(--slide-height);
  user-select: none;
`
export const EmblaControls = styled.div`
  display: flex;
  justify-content: space-around;
  margin: 3vw;
`

export const EmblaButtons = styled.div`
  display: flex;
  align-items: center;
`

export const EmblaButton  = styled.button`
  -webkit-tap-highlight-color: rgba(var(--text-high-contrast-rgb-value), 0.5);
  -webkit-appearance: none;
  appearance: none;
  background-color: transparent;
  touch-action: manipulation;
  display: inline-flex;
  text-decoration: none;
  cursor: pointer;
  border: 0;
  padding: 0;
  margin: 0 5vw;
  box-shadow: inset 0 0 0 1vw var(--detail-medium-contrast);
  width: 5vw;
  height: 5vw;
  z-index: 1;
  border-radius: 5vw;
  color: var(--text-body);
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 600px) {
    width: 10vw;
    height: 10vw;
  }
`

export const EmblaButtonSVG = styled.svg`
  width: 10vw;
  height: 10vw;
`


export const pulsing = keyframes`
  0%, 100% {
    transform: scale(1);
  } 
  50% {
    transform: scale(1.1);
  }
`;

export const BackgroundImage = styled.img`
  z-index: -1;
  position: absolute;
  top: 0vw;
  width: 80vw;
  left: 0vw;
  
  animation: ${pulsing} 20s infinite ease-in-out;

  @media (max-width: 600px) {
    top: 0vw;
    width: 200vw;
    min-height: 200vw;
  }
`;
